var slot = 'fx_2d2fb1e5_1n50dn60';

export { slot };
//# sourceMappingURL=slot.vanilla.mjs.map
